import { Injectable } from '@angular/core';
import { Observable, of, tap, throwError } from 'rxjs';
import { AuthUserInfo } from 'src/app/models/index';
import { CommonService, UtilitiesService } from 'src/app/services/index';
import { environment } from 'src/environments/environment';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$, Constants } from '../shared/index';
import { HttpClient, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public userActivities = [];
  public userRole = '';
  public userMenus = [];
  refreshtokenurl:String =environment.refresh_token_url;
  private getUserInfoUrl = `${API_ENDPOINT$}/common/getCurrentUserDetailIam`;
  // private getUserInfoUrl = `${API_ENDPOINT$}/user/user-detail`;
  private loginOauthenUrl = `${API_ENDPOINT$}/authentication/token`;
  private logoutUrl = `${API_ENDPOINT$}/authentication/revoke-token`;
  private check_tokenUrl = `${API_ENDPOINT$}/authentication/check_token`;
  private takeOutFirstTimeOfUserUrl = `${API_ENDPOINT$}/common/takeOutFirstTimeOfUser`;
  //private heartBeatUrl = `${API_ENDPOINT$}/authentication/heart-beat`;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService
  ) {}
  public defaultMenus = [];

  

  public getLogoutUrl(): string {
    return this.logoutUrl;
  }

  public login = (username: string, password: string): Observable<any> => {
    return this.dataService.postLogin(this.loginOauthenUrl, username, password);
  };

  public getRefreshtokenStorage() {

    let params = new HttpParams();
    params = params.append('code', localStorage.getItem('refresh_token'));
    params = params.append('isRefresh', 'true');
    params = params.delete('user_key');

    // params = params.append('shift', shiftType);
    // return this.http.get<ApiResponse<ProductionProgress>>(`${this.BASE_URL}/prodProgress`,{params: params})

    return this.http.get<any>(environment.refresh_token_url, { params }).pipe(
      tap((response) => {
        // Update tokens in local storage
        this.updateTokens(response);
      })
    );
  }
  updateTokens(tokens){
    localStorage.setItem('access_token', tokens.accessToken);
    localStorage.setItem('id_token', tokens.idToken);
    localStorage.setItem('refresh_token', tokens.refreshCode);

  }

  logout() {
    this.dataService.getData(this.logoutUrl, false);
    this.utilitiesService.removePlantLogo();
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }
  getUserDetail(): Observable<any> {
    return this.dataService.getData(this.getUserInfoUrl);
  }
  /** Get user info from token */
  public getLoggedUser = (): Observable<AuthUserInfo> => {
    return of(this.getAuthUserInfo());
  };
  private loginHandlerError = (error: Response): any => {
    return throwError(error);
  };
  private getAuthUserInfo = (): AuthUserInfo => {
    let user = new AuthUserInfo();
    // user = JSON.parse(localStorage.getItem('currentUser'));
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      user = currentUser;
    }
    return user;
  };
  /**
   * Validate token
   * If validated, store the token into local Storge to use for all next requests based on Json Web Token(JWT)
   * */
  private validateToken = (dataToken: any): void => {
    // if (!dataToken.access_token || this.jwtHelper.isTokenExpired(dataToken.access_token)) {
    //     return null;
    // }
    // try {
    //     this.addTokens(dataToken);
    // } catch (ex) {
    // }
  };

  public isTokenExpired = (): boolean => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.expires_at) {
      const now = Math.round(new Date().getTime() / 1000);
      return now >= currentUser.expires_at;
    }
    return false;
  };
  public refreshToken = (): Observable<any> => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      return null;
    }
    return this.dataService.refreshToken(
      this.loginOauthenUrl,
      currentUser.refresh_token
    );
  };

  public isMenuAvailable = (activities): boolean => {
    let result = false;
    for (let i = 0; i < activities.length; i++) {
      if (this.userActivities.indexOf(activities[i]) !== -1) {
        result = true;
        break;
      }
    }
    return result;
  };
  public doAuthorization = (activities): boolean => {
    let authorized = false;
    for (let i = 0; i < activities.length; i++) {
      const find = this.userActivities.find((c) => c === activities[i]);
      if (!this.commonService.isNullOrUndefined(find)) {
        authorized = true;
        break;
      }
    }
    return authorized;
  };
  public isAdmin = (): boolean => {
    return (
      this.userRole === Constants.USER_ROLE.ADMIN ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L1 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L2 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L3 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L4 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L5 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L6 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L7
    );
  };
  public isSiteAdmin = (): boolean => {
    return this.userRole === Constants.USER_ROLE.SITE_OWNER;
  };

  buildMenus(
    defaultMenus: any,
    menus: any,
    firstTime?: boolean,
    lang?: string
  ): any[] {
    if (firstTime) {
      this.buildLangDefaultMenu(lang);
      defaultMenus = this.defaultMenus;
    }
    defaultMenus.forEach((me) => {
      const menu = this.userMenus.find((c) => c.code === me.code);
      if (!this.commonService.isNullOrUndefined(menu)) {
        const newItem = Object.assign({}, me);

        if (me.items !== undefined && me.items.length > 0) {
          newItem.items = [];
          for (let i = 0; i < me.items.length; i++) {
            const element: any = me.items[i];
            const child = this.userMenus.find((c) => c.code === element.code);
            if (!this.commonService.isNullOrUndefined(child)) {
              newItem.items.push(element);
            }
            if (element.items !== undefined && element.items.length > 0) {
              newItem.items = this.buildMenus(element.items, newItem.items);
            }
          }
          menus.push(newItem);
        } else {
          if (newItem.code === 'PRODVW') {
            newItem.active = false;
            newItem.cb = () => {
              window.open(`${environment.productionViewUrl}`, 'blank');
            };
          }
          menus.push(newItem);
        }
      }
    });
    // if (menus.nodes !== undefined && menus.nodes.length > 0) {
    //   node.nodes = [];
    //   for (let i = 0; i < obj.nodes.length; i++) {
    //     const element = obj.nodes[i];
    //     element.index = i;
    //     node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
    //   }
    // }
    return menus;
  }
  takeOutFirstTimeOfUser(): Observable<any> {
    return this.dataService.getData(this.takeOutFirstTimeOfUserUrl);
  }

  buildLangDefaultMenu(lang) {
    if (lang === 'jp') {
      this.defaultMenus = Constants.defaultMenus.Japanese;
    } else {
      this.defaultMenus = Constants.defaultMenus.English;
    }
  }

  // sendHeartBeat(): Observable<any> {
  //   return this.dataService.getData(this.heartBeatUrl, false);
  // }
}
